import api from "../../checkout/services/api";
import { mapGetters } from "vuex";
import Addon from "./Partials/Addon.vue";

export default {
    components: {
        Addon
    },

    data() {
        return {
            addons: {},
        }
    },

    computed: {
        ...mapGetters(["checkout"]),
    },

    methods: {
        getBundles() {
            if (!this.checkout.tv_tariff) {
                api.get(`/public-api/get-bundles/${this.checkout.tariff}`)
                    .then(response => this.addons = response.data);
            } else {
                api.get(`/public-api/get-bundles/${this.checkout.tv_tariff}`)
                    .then(response => this.addons = response.data);
            }
        },
    },

    mounted() {
        this.getBundles()
    }
}
